export default __webpack_public_path__ + "static/media/house-svgrepo-com.9c8060b5.svg";